import api from "./api";
import { WishlistApiResponse } from "../types/store";
import { AxiosError } from "axios";

export const fetchWishlist = async () => {
  const response = await api.get<WishlistApiResponse>("/wishlist");
  return response.data;
};

export const addWishlistItem = async (productId: number) => {
  try {
    const response = await api.post<WishlistApiResponse>("/wishlist/items", {
      productId,
    });
    return response.data;
  } catch (error) {
    if (error instanceof AxiosError && error.response?.status === 400) {
      const message = String(error.response.data?.message ?? "").toLowerCase();
      if (message.includes("already in wishlist")) {
        const refreshed = await fetchWishlist();
        return refreshed;
      }
    }
    throw error;
  }
};

export const removeWishlistItem = async (itemId: number) => {
  const response = await api.delete<WishlistApiResponse>(`/wishlist/items/${itemId}`);
  return response.data;
};
